define(['jQuery',
        'library/fcse-compatibility/object',
        'clientComponents/googletagmanager/GtmBase'],

    /**
     * @returns {GtmEventTracker}
     */
    function ($, Object, GtmBase) {

        function GtmEventTracker(options) {
            GtmBase.apply(this, arguments);

            $('body').on('click', '[data-gtm-event="analyticsEvent"]', $.proxy(this._trackElementClick, this));
            $('body').on('gtm.analyticsEvent', $.proxy(function (e, originEvent) {
                this._trackElementClick(originEvent);
            }, this));
        }

        GtmEventTracker.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmEventTracker.prototype */{
            trackPage: function () {
            },
            _trackElementClick: function (event) {
                if (!event) {
                    return;
                }

                let source = false;
                if (typeof event.source !== 'undefined') {
                    source = event.source;
                }

                if (typeof event.event !== 'undefined') {
                    event = event.event;
                }

                const $elem = $(event.currentTarget);
                if ($elem.data('toggle') === "navbar-menu" && !source) {
                    event.preventDefault();
                    return;
                }

                if (!$elem.data('gtm-event')) {
                    return;
                }

                const targetUrl = $elem.attr('href');
                let redirectFunction = function () {
                };

                if (targetUrl && !(/^#.*/i).test(targetUrl)) {
                    event.preventDefault();
                    redirectFunction = function () {
                        document.location = targetUrl
                    }
                }

                window.setTimeout(redirectFunction, 2000);

                let action = $elem.data('gtm-action');
                try {
                    const product = JSON.parse(atob(action));
                    if (product && typeof product.id !== 'undefined') {
                        action = product;
                    }
                } catch (e) {
                }

                const analyticsEvent = {
                    event: 'analyticsEvent',
                    eventCategory: $elem.data('gtm-category'),
                    eventAction: action,
                    eventCallback: redirectFunction
                };

                if ($elem.data('gtm-label')) {
                    analyticsEvent.eventLabel = $elem.data('gtm-label');
                }
                this.trackEvent(analyticsEvent);
            },
            _scopeParamChanged: function (event) {
                const self = this;
                if (event.changedParams) {
                    $.each(event.changedParams, function (i, paramName) {
                        let label = '';
                        const param = event.scope.getParam(paramName);

                        if (typeof param === 'string' || typeof param === 'number' || typeof param === 'boolean') {
                            label = param;
                        } else if (Array.isArray(param)) {
                            label = param.sort().join(';');
                        }

                        self.trackEvent({
                            'event': 'analyticsEvent',
                            'eventCategory': 'Filter',
                            'eventAction': paramName,
                            'eventLabel': label
                        });
                    });
                }
            }
        });

        return GtmEventTracker;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmEventTracker.js